module.exports = __webpack_public_path__ + "public/img/保养中.f92400cf.png";